import React from "react";
import Layout from "../components/layout";
import { SEO } from "../components/seo";

import {
  domainHero,
  heroImg,
  headBasic,
  doFlex,
  flexColumn,
  container,
  ltmdDisabled,
  domainInput,
} from '../components/main.module.scss'

import {
  heroP,
  pricingDiv,
  domainheroContent,
  domainPrices,
} from '../components/hero.module.scss'

import { StaticImage } from "gatsby-plugin-image";
import Section from "../components/section";
import Minfeatures from "../components/minimalfeature";
import AboutSection from "../components/aboutsection";
import Knowmore from "../components/knowmore";
import Faqs from "../components/faq";

const Domain = () => {
  return (
    <Layout>
      <div className={domainHero}>
        <div className={`${doFlex} ${container}`}>
          <div className={`${heroImg} ${ltmdDisabled}`}>
            <StaticImage src="../images/domainhero.png" alt="Domain Name" layout="constrained" quality="100" />
          </div>
          <div className={`${doFlex} ${flexColumn} ${domainheroContent}`}>
            <h1 className={headBasic}>Get your perfect name</h1>
            <p className={heroP}>Secure your online presence with our domain name registration service. Find the perfect domain name for your website, blog, or online business and establish a strong online identity. Choose from a wide range of domain extensions now.</p>
            <div className={domainInput}>
              {/* <form action="https://bigboxhost.com/portal/cart.php?a=add&domain=register" method="post">
                Find your Domain: <input type="text" name="query" size="20" />
                <input type="submit" value="Go" />
              </form> */}

              <form action="https://bigboxhost.com/portal/cart.php?a=add&domain=register" method="post">
                {/* Find your Domain: <input type="text" name="query" size="20" /> */}
                <input type="text" placeholder="Enter your domain name" name="query"/>
                <button type="submit">Get Now</button>
                {/* <input type="submit" value="Go" /> */}
              </form>
              {/* <input type="text" placeholder="Enter your domain name" /> */}
              {/* <button type="button">Get Now</button> */}
            </div>
            <div>
              <div className={pricingDiv}>
                <div className={domainPrices}>.com <span>$12.50/yr</span></div>
                <span></span>
                <div className={domainPrices}>.net <span>$14.00/yr</span></div>
                <span></span>
                <div className={domainPrices}>.org <span>$14.00/yr</span></div>
                <span></span>
                <div className={domainPrices}>.us <span>$8.50/yr</span></div>
                <span></span>
                <div className={domainPrices}>.in <span>$12.00/yr</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Section sectionName="Get more with web hosting Plans" sectionType="1" sectionHigh="0">
        <Minfeatures center="1" pagename="domainname"></Minfeatures>
      </Section>
      <AboutSection divContent={<><h2>Why to choose BigBoxHost as your Domain Registrar?</h2>
        <p>When it comes to selecting a domain registrar, BigBoxHost stands out as a top choice. With a reputation for reliability, competitive pricing, and exceptional customer service, we offer an unparalleled domain registration experience.</p>
        <p>Our user-friendly platform, extensive domain selection, and robust management features make us the preferred partner for individuals and businesses alike. Whether you're launching a new website, rebranding your online presence, or simply securing your online identity, BigBoxHost provides the tools and support you need to succeed.</p></>}>
        <StaticImage src="../images/vpsabout.png" placeholder="blurred" alt="Why Choose BigBoxHost?" quality="100" />
      </AboutSection>
      <Knowmore />
      <Section sectionName="Frequently Asked Questions" sectionType="1">
        {faqData.map((data, index) => (
          <Faqs
            key={index}
            questions={data.questions}
            answers={data.answers}
          ></Faqs>
        ))
        }
      </Section>
    </Layout>
  );
};


export default Domain;

const faqData = [
  {
    questions: (
      <>What is domain name, and why is it required?</>
    ),
    answers: (
      <>
        <p>
          A domain name is a unique, human-readable address that represents a website on the internet. It serves as the online identity and address for your website, allowing users to access your website by simply typing the domain name into their web browser.
        </p>
        <p>
          A domain name is required for several reasons. Firstly, it provides a professional and branded online presence for businesses, organizations, and individuals. It establishes credibility and helps build trust with website visitors. Additionally, a domain name enables you to have personalized email addresses that match your domain, creating a more professional image for communication.
        </p>
        <p>
          Furthermore, a domain name is essential for effective online marketing and search engine optimization (SEO). It helps people find your website easily, enhances your online visibility, and improves your chances of being discovered by potential customers or visitors. Having a memorable and relevant domain name also contributes to better brand recognition and recall.
        </p>

      </>
    )
  }, 
  {
    questions: (
      <>How do I register a domain with BigBoxHost?</>
    ),
    answers: (
      <>
        <p>
        Registering a domain with BigBoxHost is quick and easy. Simply search for your desired domain name using our domain search tool, check its availability, and proceed with the registration process. Follow the prompts to provide the necessary information and complete the registration. Our intuitive interface and step-by-step guidance ensure a seamless domain registration experience.
        </p>
      </>
    )
  },
  {
    questions: (
      <>Can I transfer my existing domain to BigBoxHost?</>
    ),
    answers: (
      <>
        <p>
        Yes, you can transfer your existing domain to BigBoxHost. We offer domain transfer services, allowing you to consolidate your domains under one registrar. The transfer process involves unlocking your domain, obtaining an authorization code, and initiating the transfer through our platform. Our support team is available to assist you throughout the transfer process, ensuring a smooth and hassle-free transition.
        </p>
      </>
    )
  },
  {
    questions: (
      <>Does BigBoxHost offer domain privacy protection?</>
    ),
    answers: (
      <>
        <p>
        Yes, we offer domain privacy protection to safeguard your personal information. With our domain privacy service, your contact details are shielded from public WHOIS searches, protecting you against spam, unsolicited contacts, and identity theft. Rest assured that your privacy is our priority, and we provide the necessary tools to keep your personal information confidential.
        </p>
      </>
    )
  },
  {
    questions: (
      <>What happens if my domain registration expires?</>
    ),
    answers: (
      <>
        <p>
        If your domain registration expires, there is a grace period during which you can renew your domain. However, it's essential to renew your domain before the expiration date to prevent any disruption in your online presence. We send renewal reminders to help you stay on top of your domain registrations. In case you miss the renewal period, there may be additional redemption or restoration fees to recover the domain. It's advisable to renew your domain in a timely manner to avoid any potential complications.
        </p>
      </>
    )
  },
  
]

export const Head = () => (
  <SEO title="Get Your Perfect Domain Name | Buy Cheap Domain Names - BigBoxHost" 
  description="Secure your website's identity with our affordable and reliable domain name registration services. Transfer your domain easily or find the perfect domain for your website."
  pathname="/domain-name/"
  />
)